// Owners type their Instagram / Facebook as a handle ("@name"), a bare name, or paste the full
// profile URL. Normalise all three to the bare handle so links never end up doubled
// ("instagram.com/https://instagram.com/...") and the UI can show "@handle" instead of a URL.
export function socialHandle(value?: string | null): string {
  if (!value) return '';
  let v = value.trim();
  v = v.replace(/^https?:\/\/(www\.|m\.)?(instagram|facebook|fb)\.com\//i, '');
  v = v.replace(/^@/, '').replace(/[/?#].*$/, '');
  return v;
}

export const instagramUrl = (value?: string | null) => `https://instagram.com/${socialHandle(value)}`;
export const facebookUrl = (value?: string | null) => `https://facebook.com/${socialHandle(value)}`;

// Photo credits (licence attribution) are appended to a restaurant's "about" text after this
// marker. They are legally required but visually noisy, so the About sheet tucks them away.
const CREDIT_MARKERS = ['Foto nga Wikimedia Commons:', 'Foto:'];
export function splitAbout(about?: string | null): { text: string; credits: string } {
  if (!about) return { text: '', credits: '' };
  for (const m of CREDIT_MARKERS) {
    const i = about.indexOf(m);
    if (i >= 0) return { text: about.slice(0, i).trim(), credits: about.slice(i).trim() };
  }
  return { text: about, credits: '' };
}
